import { Box, Container, Typography, Paper, Divider } from '@mui/material';

function TermsPage() {
  return (
    <Box className="page-shell">
      <Container maxWidth="md" className="page-wrap" sx={{ px: 0 }}>
        <Typography
          variant="h2"
          textAlign="center"
          sx={{ mb: 2, fontWeight: 700 }}
        >
          Terms & Conditions
        </Typography>
        <Typography
          variant="body1"
          textAlign="center"
          color="text.secondary"
          sx={{ mb: 4 }}
        >
          Gorty's Tech, LLC
        </Typography>

        <Paper sx={{ p: { xs: 3, md: 4 } }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
            Last updated: January 2026
          </Typography>

          <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
            Acceptance of Terms
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            By accessing and using this website or requesting services from
            Gorty's Tech, LLC, you agree to be bound by these Terms & Conditions.
            If you do not agree to these terms, please do not use our website or
            services.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
            Services
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Gorty's Tech, LLC provides software development, deployment, and
            database administration services. Service requests submitted through
            our website are not binding agreements. Actual services will be
            provided under separate written agreements that define scope,
            deliverables, timelines, and payment terms.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
            SMS Terms & Conditions
          </Typography>
          <Box className="legal-callout" sx={{ mb: 3 }}>
            <Typography variant="body1" sx={{ mb: 2 }}>
              By providing your phone number and opting into SMS messages from
              Gorty's Tech, LLC, you agree to receive text messages related to
              service requests, appointment scheduling, project updates, and
              customer support.
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              <strong>Message frequency varies.</strong> Message and data rates
              may apply.
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              You may opt out at any time by replying <strong>STOP</strong>.
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              For help, reply <strong>HELP</strong> or contact Gorty's Tech, LLC
              through the contact information provided on this website.
            </Typography>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Carriers are not liable for delayed or undelivered messages.
            </Typography>
            <Typography variant="body1" fontStyle="italic">
              Messaging consent is optional and is not required to request
              services.
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
            Intellectual Property
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            The content, design, and code of this website are the property of
            Gorty's Tech, LLC unless otherwise noted. You may not copy,
            reproduce, or distribute website content without permission.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
            Limitation of Liability
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Gorty's Tech, LLC provides this website and information on an "as is"
            basis. We make no warranties about the accuracy or completeness of
            website content. Our liability for any claims arising from your use
            of this website is limited to the maximum extent permitted by law.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
            Privacy
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Your use of this website is also governed by our Privacy Policy,
            which describes how we collect, use, and protect your information.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
            Changes to Terms
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            We may update these Terms & Conditions from time to time. Continued
            use of our website after changes are posted constitutes acceptance of
            the updated terms.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
            Contact
          </Typography>
          <Typography variant="body1">
            If you have questions about these Terms & Conditions, please contact
            Gorty's Tech, LLC through our website's contact form or at the email
            address provided on our website.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}

export default TermsPage;
